import React, { useEffect, ChangeEvent } from 'react';
import Select from 'react-select';
import { Col, Input, Label, Row } from 'reactstrap';
import { DeleteLessonFormProp } from '../../../../../types/Forms';
import { useTranslation } from 'react-i18next';
import { getCourseLessons } from '../../../../../services/api';
import { CourseLesson } from '../../../../../types/Tables';
const MigrationStepForm: React.FC<DeleteLessonFormProp> = ({
  lessionTitle,
  courseId,
  formData,
  updateFormData,
  register,
  errors,
}) => {
  const [lessons, setLessons] = React.useState<Array<{ id: number; title: string }>>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (courseId) {
      getCourseLessons(courseId)
        .then((data) => {
          console.log('Fetched lessons for migration step:', data);
          const formatedLessons = data
            .filter((lesson: CourseLesson) => lesson.title !== lessionTitle)
            .map((lesson: CourseLesson) => ({ id: lesson.id, title: lesson.title }));
          setLessons(formatedLessons);
        })
        .catch((error) => {
          console.error('Error fetching lessons for migration step:', error);
        });
    }
  }, [courseId, lessionTitle]);

  return (
    <Row className="g-3">
      <h2 className="mb-3">{t('courses.lessons.deleteLessonWizard.step2Title')}</h2>
      <Col xs="12">
        {/* react-select expects options with `value`/`label` by default — use string values to match form field */}
        <Select<{ value: string; label: string }, false>
          options={lessons.map((l) => ({ value: String(l.id), label: l.title }))}
          closeMenuOnSelect={true}
          className="custom-selector no_placeholder"
          classNamePrefix={'custom-selector'}
          // styles={colourStyles}
          formatOptionLabel={(option: any) => <span>{option.label}</span>}
          name="migrateToLesson"
          value={
            formData.migrateToLesson
              ? {
                  value: String(formData.migrateToLesson.id),
                  label: formData.migrateToLesson.title,
                }
              : null
          }
          onChange={(selected) => {
            if (selected) {
              // send structured payload (name/value) to parent; parent handles both event and payload
              updateFormData({
                name: 'migrateToLesson',
                value: { id: Number(selected.value), title: selected.label },
              });
              // also update migrateToLessonId for backward compatibility
              updateFormData({ name: 'migrateToLessonId', value: Number(selected.value) });
            } else {
              updateFormData({ name: 'migrateToLesson', value: null });
              updateFormData({ name: 'migrateToLessonId', value: null });
            }
          }}
          placeholder={
            t('courses.lessons.deleteLessonWizard.selectPlaceholder') ||
            'Select lesson to migrate to'
          }
        />
      </Col>
    </Row>
  );
};
export default MigrationStepForm;
